import data from "../../.sourceflow/salary.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const salary_helper = new CollectionHelper(data);
